export default __webpack_public_path__ + "static/media/SZ04.1eb51ae1.mp3";